import { render, staticRenderFns } from "./CustomPostTestScreen.vue?vue&type=template&id=76c9ab56"
import script from "./CustomPostTestScreen.vue?vue&type=script&lang=js"
export * from "./CustomPostTestScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports